import React from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { getColorFromUserState } from 'erisxkit/client';
import { memberUser, serviceAccountUser } from '../constants/userTypes';
import { memberColumnXTable7 } from '../common/table/commonMetadata';
import { formatTimeLocal } from '../utils/time';
import {
  SelectColumnFilter,
  DefaultColumnNoDelayFilter,
  NamesFilter,
  DateRangeColumnFilter,
  SelectColumnFilterWithUrl,
} from '../common/table/Filters';
import * as USER_STATES from '../constants/userStates';
import { concatStrings } from '../utils/methods';
import get from 'lodash/get';

export const CLONE_MEMBER_USER_COLUMN = 'clone';

const IndexMetadata = (toggleDisable, type, onClone, isReadOnlyRole) => {
  const columns = [
    {
      Header: 'Member Name',
      id: 'member_name',
      width: 200,
      Filter: NamesFilter,
      accessor: (u) => concatStrings([u.firstName, u.middleName, u.lastName]),
    },
    {
      Header: 'Email',
      id: 'email',
      accessor: 'email',
      hideFilter: type === memberUser,
    },
    memberColumnXTable7({ hideFilter: true }),
    {
      Header: 'Created Date',
      id: 'created_at',
      accessor: (u) => formatTimeLocal(u.createdAt),
      Filter: DateRangeColumnFilter,
      hideFilter: true,
    },
    {
      Header: 'User Id',
      id: 'id',
      accessor: 'userId',
      filterOp: 'eq',
      Filter: DefaultColumnNoDelayFilter,
    },
    {
      Header: 'Auth Id',
      id: 'auth_id',
      accessor: 'authId',
    },
  ];
  type === memberUser &&
    columns.push({
      Header: 'State',
      id: 'state',
      Filter: SelectColumnFilter,
      options: Object.values(USER_STATES),
      accessor: (d) => (
        <Label
          content={d.state || 'pending_pii'}
          color={getColorFromUserState(d.state)}
        />
      ),
      width: 140,
      filterOp: 'eq',
      getCellExportValue: (row) => get(row, 'original.state', 'pending_pii'),
    });
  columns.push({
    Header: 'Status',
    id: 'disabled',
    accessor: (d) => (
      <Label
        color={!d.disabled ? 'green' : 'red'}
        content={!d.disabled ? 'Active' : 'Disabled'}
      />
    ),
    width: 80,
    filterOp: 'eq',
    getCellExportValue: (row) =>
      get(row, 'original.disabled', false) ? 'Disabled' : 'Active',
    Filter: SelectColumnFilterWithUrl,
    options: ['active', 'disabled'],
  });
  type === memberUser &&
    columns.push({
      Header: '',
      id: 'disable',
      accessor: (d) => (
        <Icon
          onClick={() => toggleDisable(d)}
          link
          name={d.disabled ? 'check' : 'eye slash'}
          disabled={isReadOnlyRole}
        />
      ),
      filterable: false,
      hideFilter: true,
      width: 35,
      disableExport: true,
    });

  type === memberUser &&
    columns.push({
      Header: 'Clone',
      id: CLONE_MEMBER_USER_COLUMN,
      accessor: (memberUser) => {
        const isDisabled = isReadOnlyRole || memberUser.memberUserType === serviceAccountUser;
        return (
          <Icon
            onClick={() => !isDisabled && onClone(memberUser)}
            name="clone"
            disabled={isDisabled}
          />
        );
      },
      filterable: false,
      hideFilter: true,
      width: 50,
      disableExport: true,
    });

  return columns;
};
export default IndexMetadata;
